import "./App.css";
import { useEffect, useState } from "react";
import React from "react";
import loader from "./Images/loading/loading.gif";
import Footer from "./Components/footer";
import Home from "./Pages/Home";

function App() {

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 4000);
  }, []);
  
  return (
    <div className="bg-black w-full h-screen">
      {loading ? (
        <div className=" absolute top-[25%] left-[40%]">
          <img src={loader} className="rounded-full" alt="loading" />
        </div>
      ) : (
        <div className="App">
            <Home />
            <Footer />
          </div>
      )}
    </div>
  );
}

export default App;
